import React from "react";
import classnames from "classnames";
// reactstrap components
import {
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

export default function Tabs() {
  const [iconTabs, setIconsTabs] = React.useState(1);
  return (
    <section className="section section-lg">
      <Container>
        <Row className="justify-content-center">
          <Col lg="12">
            <h1 className="text-center">Hizmetlerimiz</h1>
            <p className="text-center">
              Size özel profesyonel çözümlerimizle işletmenizi güvence altına
              alıyoruz.
            </p>
            <Nav
              className="nav-pills-primary nav-pills-lg justify-content-center"
              pills
              role="tablist"
            >
              <NavItem>
                <NavLink
                  className={classnames({
                    active: iconTabs === 1,
                  })}
                  onClick={(e) => setIconsTabs(1)}
                  href="#pablo"
                >
                  <i className="tim-icons icon-settings-gear-63" />
                  İş Güvenliği Uzmanlığı
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: iconTabs === 2,
                  })}
                  onClick={(e) => setIconsTabs(2)}
                  href="#pablo"
                >
                  <i className="tim-icons icon-heart-2" />
                  İşyeri Hekimliği
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: iconTabs === 3,
                  })}
                  onClick={(e) => setIconsTabs(3)}
                  href="#pablo"
                >
                  <i className="tim-icons icon-satisfied" />
                  Diğer Sağlık Personeli
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent
              className="tab-space"
              activeTab={"link" + iconTabs}
            >
              <TabPane tabId="link1">
                <h3 className="text-center">İş Güvenliği Uzmanlığı</h3>
                <p className="description">
                  Elit OSGB olarak, işyerlerinde güvenli çalışma ortamlarının
                  sağlanması için gerekli yasal düzenlemelere uygun olarak iş
                  güvenliği uzmanlarımız tarafından kapsamlı bir destek ve
                  danışmanlık sunulmaktadır. Müşterilerimizin iş güvenliği
                  alanındaki ihtiyaçlarını karşılamak ve en yüksek standartlarda
                  güvenli çalışma koşullarını sağlamak için çeşitli hizmetler
                  sunuyoruz. Amacımız, müşterilerimize iş güvenliği konusunda
                  eksiksiz bir çözüm sunarak işyerlerinde güvenli çalışma
                  kültürünü teşvik etmek ve kazaların önlenmesine katkıda
                  bulunmaktır.
                </p>
                <Row className="text-center mt-5">
                  <Col md="4">
                    <div className="info">
                      <div className="icon icon-primary">
                        <i className="tim-icons icon-zoom-split" />
                      </div>
                      <h4 className="info-title">Risk Analizi</h4>
                      <p className="description">
                        İşyerinizdeki tüm tehlike ve risklerin detaylı olarak
                        belirlenmesi ve raporlanması.
                      </p>
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="info">
                      <div className="icon icon-primary">
                        <i className="tim-icons icon-bulb-63" />
                      </div>
                      <h4 className="info-title">İSG Eğitimleri</h4>
                      <p className="description">
                        Çalışanlarınıza yönelik yasal olarak zorunlu ve sektöre
                        özel temel İSG eğitimleri.
                      </p>
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="info">
                      <div className="icon icon-primary">
                        <i className="tim-icons icon-notes" />
                      </div>
                      <h4 className="info-title">Acil Durum Planı</h4>
                      <p className="description">
                        Olası acil durumlar için eylem planlarının hazırlanması
                        ve tatbikatların yapılması.
                      </p>
                    </div>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="link2">
                <h3 className="text-center">İşyeri Hekimliği Hizmeti</h3>
                <p className="description">
                  İş yeri hekimliği, iş sağlığı ve güvenliği alanında önemli bir
                  rol oynayan ve işyerlerinde çalışanların sağlığını korumayı
                  amaçlayan bir hizmettir. Elit OSGB olarak, iş yerlerinde
                  çalışanların sağlığını korumak ve iş kazalarını önlemek
                  amacıyla uzmanlaşmış hekimlerimiz, işyerlerindeki sağlık
                  risklerini belirlemek ve çalışanları bu risklere karşı korumak
                  için düzenli sağlık kontrolleri ve tıbbi muayeneler
                  yapmaktadır.
                </p>
                <Row className="text-center mt-5">
                  <Col md="4">
                    <div className="info">
                      <div className="icon icon-info">
                        <i className="tim-icons icon-single-02" />
                      </div>
                      <h4 className="info-title">İşe Giriş Muayenesi</h4>
                      <p className="description">
                        Yeni başlayacak çalışanların işe uygunluğunun tespit
                        edilmesi için detaylı muayeneler.
                      </p>
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="info">
                      <div className="icon icon-info">
                        <i className="tim-icons icon-refresh-02" />
                      </div>
                      <h4 className="info-title">Periyodik Muayene</h4>
                      <p className="description">
                        Çalışanların sağlık durumlarının düzenli olarak takip
                        edilmesi ve raporlanması.
                      </p>
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="info">
                      <div className="icon icon-info">
                        <i className="tim-icons icon-heart-2" />
                      </div>
                      <h4 className="info-title">Sağlık Eğitimleri</h4>
                      <p className="description">
                        Hijyen, ergonomi ve genel sağlık konularında
                        çalışanların bilinçlendirilmesi.
                      </p>
                    </div>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="link3">
                <h3 className="text-center">
                  Diğer Sağlık Personeli (DSP)
                </h3>
                <p className="description">
                  Diğer Sağlık Personeli (DSP) veya İşyeri Hemşiresi hizmeti, iş
                  sağlığı ve güvenliği kapsamında işyerlerinde sunulan önemli
                  sağlık destek hizmetlerinden biridir. DSP'ler, İşyeri
                  Hekimleri ve İş Güvenliği Uzmanları ile koordineli bir şekilde
                  çalışarak, işyerinde sağlıklı ve güvenli bir çalışma
                  ortamının sürdürülmesine katkıda bulunurlar. Çalışanların
                  sağlık verilerinin takibi ve ilk müdahale konusunda kritik
öeneme sahiptirler.
                </p>
                <Row className="text-center mt-5">
                  <Col md="4">
                    <div className="info">
                      <div className="icon icon-success">
                        <i className="tim-icons icon-sound-wave" />
                      </div>
                      <h4 className="info-title">İlkyardım Desteği</h4>
                      <p className="description">
                        Acil durumlarda ilk müdahalenin yapılması ve gerekli
                        sağlık kuruluşlarına yönlendirme.
                      </p>
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="info">
                      <div className="icon icon-success">
                        <i className="tim-icons icon-chart-bar-32" />
                      </div>
                      <h4 className="info-title">Kayıt ve Takip</h4>
                      <p className="description">
                        Çalışan sağlık dosyalarının düzenlenmesi, sağlık
                        tetkiklerinin takibi ve arşivlenmesi.
                      </p>
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="info">
                      <div className="icon icon-success">
                        <i className="tim-icons icon-badge" />
                      </div>
                      <h4 className="info-title">Poliklinik Hizmetleri</h4>
                      <p className="description">
                        İşyeri hekimine asiste ederek günlük sağlık muayenesi ve
                        revir hizmetlerinin yürütülmesi.
                      </p>
                    </div>
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
